'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _Icon = require('../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Button = require('../../../components/buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _boardConstants = require('../../../../common/boards/boardConstants');

require('./ElementCreateButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var elementCreateHandlers = {
    createElement: function createElement(props) {
        return function (event) {
            var dispatchCreateElement = props.dispatchCreateElement,
                dispatchClosePopup = props.dispatchClosePopup,
                elementType = props.elementType,
                currentBoardId = props.currentBoardId,
                inboxCount = props.inboxCount;


            var location = {
                parentId: currentBoardId,
                section: _boardConstants.BOARD_SECTIONS.INBOX,
                position: { index: inboxCount }
            };

            dispatchClosePopup();

            dispatchCreateElement({
                elementType: elementType,
                location: location
            });
        };
    }
};

var ElementCreateButton = function ElementCreateButton(_ref) {
    var elementType = _ref.elementType,
        name = _ref.name,
        createElement = _ref.createElement;
    return _react2.default.createElement(
        'li',
        { className: 'ElementCreateButton' },
        _react2.default.createElement(
            _Button2.default,
            { className: 'feedback', onClickFn: createElement },
            _react2.default.createElement(
                'div',
                { className: 'button-content' },
                _react2.default.createElement(_Icon2.default, { name: 'element-' + elementType.toLowerCase(), size: _Icon.ICON_SIZES.SMALL }),
                _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    name
                )
            )
        )
    );
};

ElementCreateButton.propTypes = {
    elementType: _propTypes2.default.string,
    name: _propTypes2.default.string,
    createElement: _propTypes2.default.func,
    currentBoardId: _propTypes2.default.string,
    inboxCount: _propTypes2.default.number
};

exports.default = (0, _recompose.withHandlers)(elementCreateHandlers)(ElementCreateButton);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/elementCreate/ElementCreateButton.js
// module id = 2212
// module chunks = 0